module.exports = __webpack_public_path__ + "static/IMG_7889-892f82dba1c8fc3281a9eef3c24181ab.jpg";